// 西班牙语
export default {
    header_menu: {
        home: "Inicio",
        about: "Sobre nosotros",
        product: "Productos",
        news: "Noticias",
        news_content: "Detalle de la noticia",
        download: "Centro de descargas",
        contact: "Contacto",
    },
    read_more: "Leer más",
    prev: "Artículo anterior",
    next: "Artículo siguiente",
    quick_navigation: "Navegación rápida",
    phone: "Teléfono",
    whatsapp: "WhatsApp",
    email: "Correo electrónico",
    address: "Dirección",
    your_name: "Su nombre",
    your_email: "Su correo electrónico",
    content: "Contenido",
    please_input: "Por favor ingrese ",
    leave_message: "Enviar consulta",
    leave_success: "Mensaje enviado con éxito",
    click_count: "Número de clics",
    create_time: "Fecha de creación",
    upload_time: "Fecha de carga",
    //下载（动作）
    download: "Descargar",
    resources: "Recursos",
    products_type1: "Categorías de Productos",
    products_type2: "Subcategorías",
    products_type3: "Subcategorías",
    products_list: "Lista de productos",
    products_detail: "Detalles del producto",
    products_video: "Video del producto",
    send_message: "Enviar consulta",
    products_content: "Contenido del producto",
    categories: "Categorías",
    send_email: "Enviar correo electrónico",
    call_time: "Horario de atención",
    our_location: "Nuestra ubicación",
    leave_message_to_us: "Envíenos una consulta",
    left_category: "Categorías",
    type_two: "Subcategorías",
    type_three: "Subcategorías",
    video_not_support: "Su navegador no admite la etiqueta de video.",
    about_us: "Sobre nosotros",
    no_data: "Sin datos",
    home_about_subtitle: "Proveedor confiable de madera y contrachapado premium para compradores globales",
    home_products_title: "Nuestros Productos",
    home_products_subtitle: "Explore nuestras categorías de productos principales",
    view_all: "Ver todo",
    home_stat_countries: "Países atendidos",
    home_stat_capacity: "Producción anual (m³)",
    home_stat_years: "Años de experiencia",
    home_stat_clients: "Clientes globales",
    footer_follow: "Síguenos en WeChat",
    footer_wechat: "WeChat",
    footer_copyright: "Debai Wood. Todos los derechos reservados.",
    home_visual_year: "Desde 2009",
    home_visual_quote: "Socio confiable de madera y contrachapado premium para compradores en más de 60 países.",
    home_visual_tag: "FSC · ISO 9001 · CE Certificado",
    cta_title: "¿Busca un proveedor confiable de madera y contrachapado?",
    cta_sub: "Obtenga un presupuesto competitivo y entrega mundial para sus pedidos de madera al por mayor.",
    get_a_quote: "Solicitar cotización",
    home_banner_title: "Madera y Contrachapado Premium para el Mundo",
    home_banner_sub: "Proveedor global confiable que sirve a más de 60 países con calidad certificada FSC, ISO 9001 y CE.",
    topbar_slogan: "Madera y contrachapado premium — La elección confiable de compradores en todo el mundo",
    contact_hero_tag: "Contáctanos",
    page_title: {
        home: "Debai Wood | Fabricante y Proveedor Global de Madera y Contrachapado",
        about: "Sobre Nosotros | Debai Wood",
        products: "Productos | Debai Wood",
        news: "Noticias | Debai Wood",
        download: "Centro de Descargas | Debai Wood",
        contact: "Contáctanos | Debai Wood",
        not_found: "Página No Encontrada",
        back_home: "Volver al Inicio",
    },
    page_desc: {
        home: "Debai Wood es fabricante y proveedor global de madera y contrachapado, sirviendo a 60+ países con productos certificados FSC, ISO 9001 y CE y entrega mundial.",
        about: "Conozca Debai Wood — fabricante confiable de madera y contrachapado con más de 15 años de experiencia, clientes globales y gestión de calidad certificada.",
        products: "Explore la gama completa de madera y contrachapado Debai Wood: contrachapado fenólico, OSB, MDF, madera aserrada y soluciones a medida para compradores globales.",
        news: "Últimas noticias, ferias y análisis del sector de Debai Wood — su socio confiable en madera y contrachapado.",
        download: "Descargue catálogos de productos, certificaciones (FSC, ISO 9001, CE) y fichas técnicas de Debai Wood para madera y contrachapado.",
        contact: "Contacte con Debai Wood para cotizaciones competitivas en pedidos de madera y contrachapado. Entrega mundial y soporte B2B dedicado.",
    },
}
